import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

import "./Courses.css";
import { FaClock, FaUserGraduate, FaShoppingCart } from "react-icons/fa";
import { getCourseBatch, API_BASE } from "../Services/Api";
import { useCart } from "../Context/Cartcontext";
import { useAuth } from "../Context/AuthContext";

const Courses = ({ categoryId, scrollRef }) => {
  const { cartItems, addToCart } = useCart();
  const { user } = useAuth(); // ✅ from AuthContext
  const navigate = useNavigate();


  const [courses, setCourses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [popup, setPopup] = useState({ show: false, courseName: "" });

  const [loading, setLoading] = useState(true);


  {/* ----------------------------------------------------------- */ }

  useEffect(() => {
    const fetchBatch = async () => {
      try {
        const res = await getCourseBatch(categoryId);
        setCourses(res?.courses || []);
        setCategories(res?.categories || []);
        setEnrolledCourses(res?.enrolled_courses || []);
        console.log(`print courses ${courses}`)
          console.log(`print  ${res}`)
      } catch (error) {
        console.error("Batch API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBatch();
  }, [categoryId]);

  {/* ---------------------------------------------------------- */ }


  const handleAddToCart = (course) => {

    if (!user) {
      navigate("/login", { state: { from: `/about-course/${course.id}` } });
      return;
    }

    const alreadyAdded = cartItems.some((item) => item.id === course.id);
    if (alreadyAdded) {
      alert("Course is already in your cart!");
      return;
    }

    addToCart(course);

    // Show popup
    setPopup({ show: true, courseName: course.course_name });

    // Hide popup after 3 seconds
    setTimeout(() => setPopup({ show: false, courseName: "" }), 3000);
  };


  {/* --------------------------------------------------------- */ }

  const handleGetAccess = async (moodleCourseId) => {
    try {
      const res = await fetch(`${API_BASE}/connect-course`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ courseId: moodleCourseId }),
      });

      const html = await res.text();
      document.open();
      document.write(html);
      document.close();
    } catch (err) {
      console.error("Error connecting to course:", err);
    }
  };


  {/* ------------------------------------------------------------ */ }


  // ✅ filter courses (homepage = only card_design=1)
  const filteredCourses = categoryId ? courses : courses.filter((course) => parseInt(course.card_design) === 1);

  return (
    <>
      <title>EDC - Courses </title>
      <meta name="description" content="Browse professional courses to upskill yourself in technology, business, and more." />
      <meta name="keywords" content="courses, learning, edc, education, skills" />
      <meta property="og:title" content="Courses - EDC Learning" />
      <meta property="og:description" content="Find the right course to upskill yourself." />
      <meta property="og:image" content="/images/LSClogo.png" />
      <meta property="og:url" content="https://edc.lsc-india.org/" />
      <meta name="twitter:card" content="summary_large_image" />

      <section className="popular-courses" ref={scrollRef}>
        <div className="container">
          <div className="section-title">
            <h2 className="text-4xl font-extrabold text-gray-900 leading-tight" >
              {categoryId ? "Courses in Selected Category" : "Popular Courses"}
            </h2>
            <p>Trending courses picked by our community this week</p>
          </div>

          {loading ? (
            <div className="course-grid">
              {[...Array(3)].map((_, idx) => (
                <div className="course-card" key={idx}>
                  <div className="course-image skeleton skeleton-image"></div>
                  <div className="course-content">
                    <div className="skeleton skeleton-title"></div>
                    <div className="skeleton skeleton-text"></div>
                    <div className="skeleton skeleton-text"></div>
                    <div className="skeleton skeleton-button"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : filteredCourses.length === 0 ? (
            <p className="text-center text-gray-500">No courses found.</p>
          ) : (

            <div className="course-grid" >
              {filteredCourses.map((course, index) => {
                const enrolledObj = enrolledCourses.find(
                  (e) => parseInt(e.main_course) === parseInt(course.id)
                );
                const isEnrolled = !!enrolledObj;
                // const inCart = cartItems.some((item) => item.id === course.id);
                const inCart = cartItems.some((item) => parseInt(item.id) === parseInt(course.id));


                const gstPercent = parseFloat(course.gst_precent) || 0;
                const basePrice = parseFloat(course.course_price) || 0;
                const totalPrice =
                  course.gst_flag === 0
                    ? basePrice + (basePrice * gstPercent) / 100
                    : basePrice;

                return (
                  <div className="course-card" key={index} onClick={() => navigate(`/about-course/${course.id}`)}>


                    {/* -------------------------------------------------------------------------------------------------- */}
                    <div className="course-image">
                      {/* <a
                      href={`https://edcbackend.lsc-india.org/${course.image}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    > */}
                      <img
                        src={`https://edcbackend.lsc-india.org/${course.image}`}
                        alt={course.course_name}
                        style={{ width: "100%", height: "auto", cursor: "pointer" }}
                      />
                      {/* </a> */}
                    </div>

                    <div className="course-content">

                      <span className="course-category">
                      {course.category_name}
                    </span>
                      <h3 className="course-title">{course.course_name}</h3>

                      {/* --------------------------------------gst and course price------------------------------------------------------------ */}
                     <div className="course-meta mt-5">
                          <span className="meta-item">
                            <FaClock className="icon" /> {course.course_hrs}
                          </span>

                          <span className="meta-item">
                            <FaUserGraduate className="icon" /> ₹{Math.round(totalPrice)}
                            {course.gst_flag === 0 && (
                              <small> (with {gstPercent}% GST)</small>
                            )}
                          </span>
                        </div>



                      {/* --------------------------------------button section------------------------------------------------------------ */}
                      <div className="course-footer">
                        {/* <a href={`about-course/${course.id}`} className="view-link" > View Cours </a> */}
                        <Link to={`/about-course/${course.id}`} className="view-link">View Course</Link>

                        {isEnrolled ? (
                          <button className="add-to-cart-icon-btn" onClick={() => handleGetAccess(enrolledObj.moodle_course_id)}> Get Access </button>
                        )
                          : inCart ? (
                            <button className="add-to-cart-icon-btn" disabled>  Added in Cart </button>
                          )
                            : (
                              <button className="add-to-cart-icon-btn" onClick={(e) =>{e.stopPropagation();handleAddToCart(course)}} > <FaShoppingCart className="mx-2" /> Add to Cart</button>
                            )}
                            

                      </div>
                      {/* -------------------------------------------------------------------------------------------------- */}

                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>




        {popup.show && (
          <div className="cart-popup">
            <p>
              <strong>{popup.courseName}</strong> has been added to your cart!
            </p>
          </div>
        )}



      </section>
    </>
  );
};

export default Courses;

